import React from 'react';
import { MapPin, X } from 'lucide-react';

interface AreaOption {
  areaId: number;
  name: string;
  cityName: string;
  cityId: number;
  longName: string;
  lat?: number;
  lng?: number;
}

interface AreaSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (area: AreaOption) => void;
  areas: AreaOption[];
  searchQuery: string;
}

const AreaSelectionModal = ({ isOpen, onClose, onSelect, areas, searchQuery }: AreaSelectionModalProps) => {

  const handleAreaSelect = (area: AreaOption) => {
    onSelect(area);
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="area-selection-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={handleClose}>
          <X size={20} />
        </button>

        <div className="modal-header">
          <h2>Select Area</h2>
          <p>Found {areas.length} areas matching "{searchQuery}". Please select one:</p>
        </div>

        <div className="areas-list">
          {areas.map((area) => (
            <div
              key={area.areaId}
              className="area-option"
              onClick={() => handleAreaSelect(area)}
            >
              <div className="area-info">
                <div className="area-name">
                  <MapPin size={16} className="location-icon" />
                  <span className="name">{area.name}</span>
                </div>
                <div className="area-details">
                  <span className="long-name">{area.longName}</span>
                  {area.lat && area.lng && (
                    <span className="coordinates">
                      • {area.lat.toFixed(4)}, {area.lng.toFixed(4)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <p>Click on any area to select it</p>
        </div>
      </div>
    </div>
  );
};

export default AreaSelectionModal;
